// extracted by mini-css-extract-plugin
export default {"userTagWrapper":"index_userTagWrapper__Ow--h","compact":"index_compact__LKMDh","iconContainer":"index_iconContainer__O-Iac","nameContainer":"index_nameContainer__8FAfu"};